class AudioContextManager {
    constructor() {
        this.context = null;
    }

    getContext() {
        if (!this.context || this.context.state === 'closed') {
            try {
                this.context = new (window.AudioContext || window.webkitAudioContext)();
            } catch (err) {
                console.error('Failed to create AudioContext:', err);
                return null;
            }
        }

        // Resume if suspended
        if (this.context.state === 'suspended') {
            this.context.resume().catch(err =>
              console.warn('Could not resume AudioContext:', err)
            );
        }

        return this.context;
    }

    closeContext() {
        if (this.context && this.context.state !== 'closed') {
            this.context.close().catch(err =>
              console.warn('Error closing AudioContext:', err)
            );
            this.context = null;
        }
    }
}

export default new AudioContextManager();